import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const SpecialSession = () => {
  return (
    <React.Fragment>
      <SEO title="Special Sessions | DMBD 2024" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Special Sessions"
        content="For Authors"
        contentTwo="Special Sessions"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
          <h2 id="session1">SS1: Innovations in Big Data Processing and AI: Challenges, Architectures, and Applications</h2>
          <p className="home-p text-justify">

            Rapid advancements in big data and artificial intelligence technologies have had a profound impact
            on all areas of human society including the economy, management, politics, healthcare, and education.
            Big data analytics employs a variety of artificial intelligence techniques including machine learning,
            deep learning, computational optimization, evolutionary computation, and swarm intelligence.
            The special session aims at presenting the latest developments of the artificial intelligent algorithms
            in data mining, discussing the future direction of developments, and exchanging novel ideas about
            how to overcome the challenges.
            It welcomes the original contributions that provide novel theories, frameworks and applications to algorithms.
            <br></br>
            <h4>Topics of Interest</h4>
            Topics of interest include, but are not limited to:
            <ul>
            <li>Advanced Techniques for Big Data Analytics</li>
            <li>Deep Learning Architectures for Big Data</li>
            <li>Privacy and Security in Large-Scale Data Processing</li>
            <li>Online and Adaptive Learning for Streaming Data</li>
            <li>Generative Models and Large-Scale AI Systems</li>
            <li>Utilizing large-scale generative models for diverse applications.</li>
            <li>The role of generative adversarial networks (GANs) in Big Data and AI research.</li>
            <li>Clustering, Classification, and Prediction in Big Data</li>
            <li>Predictive analytics and its impact on decision-making across various domains.</li>
            <li>Big Data Architectures and System Design</li>
            <li>Tools and technologies for improving the quality of service (QoS) in Big Data processing.</li>
            <li>Applications of Big Data and AI in Emerging Technologies</li>
            <li>Case studies showcasing the impact of Big Data analytics on emerging technologies.</li>
            </ul>

            <h4>Submission</h4>
            Please follow the DMBD&apos;2024 instruction for authors and submit your paper via the DMBD&apos;2024
            online submission system. Please specify that your paper is for &quot; SS1--Innovations in Big Data Processing and AI: Challenges, Architectures, and Applications &quot; in your paper.
          </p>

          <h4>Organizers</h4>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Affiliate</th>
                <th scope="col">Email</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="align-middle">Prof. Arun Sharma</td>
                <td className="align-middle">Information Technology Indira Gandhi Delhi Technical University for Women, Delhi</td>
                <td className="align-middle"></td>
              </tr>
              <tr>
                <td className="align-middle">Dr. Ritu Rani</td>
                <td className="align-middle">Guru Gobind Singh Indraprastha University, Delhi</td>
                <td className="align-middle">ritujangra00@gmail.com</td>
              </tr>
              <tr>
                <td className="align-middle">Dr. Garima Jaiswal</td>
                <td className="align-middle">Bennett University, India</td>
                <td className="align-middle"></td>
              </tr>
            </tbody>
          </table>
          <br></br>
          <hr></hr>

          <h2 id="session1">SS2: Harnessing the Power of Financial Large Models and Data Mining: Innovations, Applications, and Ethical Considerations</h2>
          <p className="home-p text-justify">

          The rapid advancement of artificial intelligence and machine learning technologies has profoundly transformed the financial industry. At the heart of this transformation lie financial large models, which leverage vast amounts of data and sophisticated algorithms, integrating diverse data sources such as historical market data, economic indicators, and social media sentiment to provide a more comprehensive and nuanced market understanding. These models enhance not only analytical capabilities but also enable financial institutions to make more informed and timely decisions, improve operational efficiency, and enhance customer experiences. They play a crucial role in risk management, investment strategies, regulatory compliance, and fraud detection, helping institutions adhere to regulations and safeguard against financial crimes. As the financial landscape continues to evolve, financial large models will be key to maintaining a competitive edge and driving innovation in financial services, representing a significant leap forward in the application of AI and machine learning in finance, and offering transformative benefits that enhance decision-making, efficiency, and security within the industry.
            <br></br>
            <h4>Topics of Interest</h4>
            Topics of interest include, but are not limited to:
            <ul>
            <li>Advanced algorithms for training financial large models</li>
            <li>Data preprocessing and feature engineering for large-scale financial models</li>
            <li>Optimization techniques for financial model performance</li>
            <li>Machine learning and data mining algorithms for financial data</li>
            <li>Clustering, classification, and regression in financial contexts</li>
            <li>Anomaly detection and outlier analysis in financial datasets</li>
            <li>Handling large-scale financial datasets</li>
            <li>Scalable data mining techniques for financial applications</li>
            <li>Real-time data mining and stream processing in finance</li>
            <li>Mining financial networks and relationships</li>
            <li>Social network analysis for financial insights</li>
            <li>Graph-based algorithms for fraud detection and risk analysis</li>
            <li>Ethical implications of using large models and data mining in finance</li>
            <li>Privacy-preserving data mining techniques</li>
            <li>Regulatory compliance and data governance in financial data mining</li>
            </ul>

            <h4>Submission</h4>
            Please follow the DMBD&apos;2024 instruction for authors and submit your paper via the DMBD&apos;2024
            online submission system. Please specify that your paper is for &quot; SS2--Harnessing the Power of Financial Large Models and Data Mining: Innovations, Applications, and Ethical Considerations &quot; in your paper.
          </p>

          <h4>Organizers</h4>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Affiliate</th>
                <th scope="col">Email</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="align-middle">Prof. Ying Tan</td>
                <td className="align-middle">	Peking University</td>
                <td className="align-middle">ytan@pku.edu.cn</td>
              </tr>
              <tr>
                <td className="align-middle">Wenbo Yan</td>
                <td className="align-middle">	Peking University</td>
                <td className="align-middle">	wenboyan@stu.pku.edu.cn</td>
              </tr>

            </tbody>
          </table>
          <br></br>
          <hr></hr>

          
          <div className="call-sp">


            <h2 id="callforss">DMBD 2024 Call for Special Session Proposals</h2>
            <br></br>
            <p align="justify">
              DMBD 2024 technical program will include special sessions. Their aim is to provide a
              complementary flavor to the regular sessions and should include hot topics of interest
              to the data mining and big data community that may also go beyond disciplines traditionally
              represented at DMBD.
            </p>

            <p align="justify">
              Prospective organizers of special sessions should submit proposals indicating:
              <ul >
                <li>Title of the session.</li>
                <li>Rationale of the need for the special session at DMBD.</li>
                <li>The rationale should stress the novelty of the topic and/or its multidisciplinary
                  flavor, and must explain how it is different from the subjects covered by the
                  regular sessions.</li>
                <li>Short biography of the organizers.</li>
                <li>List of 5 – 6 contributed papers (including titles, authors, contact information of
                  the corresponding author) (this can also be provided later when they become
                  available).</li>
              </ul>
            </p>


            <p align="justify">
              Proposals are due on or before August 22nd, 2024 and should be sent via e-mail (in
              either
              pdf
              or plain ASCII text form) to the special sessions chair (to be announced) and forward to
              DMBD 2024 secretariat at <a href="mailto: dmbd2024@iasei.org">dmbd2024@iasei.org</a>.
            </p>

            <p align="justify">

              Proposals will be evaluated based on the timeliness of the topic, the qualifications of
              the
              organizers and the authors of the papers proposed in the session. In its decision, the
              committee will try to realize a balance of the topics across the technical areas
              represented
              data mining and big data.

            </p>

            <p align="justify">
              Notification of acceptance will be sent to the organizers no later than August 31st,
              2024.
              Authors of papers included in approved special sessions should submit their manuscript
              on or  before 	August 31st, 2024 . Manuscripts should conform to the formatting and electronic
              submission guidelines of regular DMBD papers (Springer’s CCIS format).
            </p>

            <p align="justify">
              When they submit papers, there is a choice to indicate that their papers are special
              session
              papers which will also undergo peer review. It is the responsibility of the organizers
              to
              ensure that their special session meets the DMBD quality standards. If, at the end of
              the
              review process, less than four papers are accepted, the session will be canceled and the
              accepted papers will be moved to regular sessions.
            </p>


          </div>

        </div>
      </EmptyTwo>
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default SpecialSession;
